export const backgroundColorMap = {
  DYB: '#7F5BFF',
  CB: '#e4200e',
  YB: '#0093cd',
  VM: '#7F5BFF',
};
